import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

const getAuthHeaders = () => {
  const token = localStorage.getItem('eez7_client_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getAllRestaurants = async (params = {}) => {
  try {
    const response = await axios.get(`${BASE_API}/restaurants`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getRestaurantById = async (id) => {
  try {
    const response = await axios.get(`${BASE_API}/restaurants/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getRestaurantRatingSummary = async (id) => {
  try {
    const response = await axios.get(`${BASE_API}/restaurants/${id}/ratings/summary`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postRestaurantRating = async (id, { stars, comment }) => {
  try {
    const response = await axios.post(
      `${BASE_API}/restaurants/${id}/ratings`,
      { stars, comment },
      { headers: { ...getAuthHeaders() } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get blocked dates for a restaurant (public endpoint)
export const getBlockedDates = async (id) => {
  try {
    const response = await axios.get(`${BASE_API}/restaurants/${id}/blocked-dates`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
